import { AnyAction, configureStore, Reducer } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import { RootState } from 'prequalificationV2/actions';
import appReducer from 'prequalificationV2/actions';
import { ErrorsMessages } from 'enums/ErrorsMessages';

const initialState = localStorage.getItem('sessionStorage') ? JSON.parse(localStorage.getItem('sessionStorage')!) : {};

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (
    action.error?.message === ErrorsMessages.IncorrectEmailOrPassword ||
    action.error?.message === ErrorsMessages.RefreshTokenExpired
  ) {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }

  if (
    ['account/Logout/fulfilled', 'account/Logout/rejected'].includes(action.type) ||
    action.error?.message === ErrorsMessages.RefreshTokenExpired
  ) {
    sessionStorage.removeItem('state');

    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage: storageSession,
  blacklist: ['loading'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk as ThunkMiddleware),
  preloadedState: initialState,
});

export const persistor = persistStore(store);

export default store;
